"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var ContentCurationList = function ContentCurationList(props) {
  return (0, _preact.h)("ul", {
    className: "topic-curation__list list"
  }, props.children);
};

var _default = ContentCurationList;
exports.default = _default;